export const environment = { production: false, base_Url: 'https://api.incept.green/api/v1.0/thirdrock/', paymentKey:'rzp_test_Gtx73WmJhB5DHF' };
